import {
    NTP_SYNC_REQUEST_GET,
    NTP_SYNC_RESPONSE_GET_SUCCESS,
    NTP_SYNC_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/ntpSyncConstants";
  
  export const ntpSyncShReducer = (state = { ntpSync: {} }, action) => {
    switch (action.type) {
      case NTP_SYNC_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case NTP_SYNC_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          ntpSync: action.payload,
        };
      case NTP_SYNC_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  